/**
 * Chip compacto "Pronto Atendimento" — linguagem visual PA (error100/error700)
 * sem variant filled error (evita confusão com status cancelado).
 */
import { Chip, Tooltip } from "@mui/material";
import { MedicalServices } from "@mui/icons-material";

interface ProntoAtendimentoBadgeProps {
  /** Label curto "PA" para espaços estreitos. */
  compact?: boolean;
}

export function ProntoAtendimentoBadge({
  compact = false,
}: ProntoAtendimentoBadgeProps) {
  return (
    <Tooltip title="Atendimento via fila de Pronto Atendimento">
      <Chip
       
        variant="outlined"
        icon={<MedicalServices sx={{ fontSize: 14 }} />}
        label={compact ? "PA" : "Pronto Atendimento"}
        sx={{
          height: 20,
          bgcolor: "error100.main",
          color: "error700.main",
          borderColor: "error.main",
          "& .MuiChip-icon": { ml: 0.5, color: "error700.main" },
          "& .MuiChip-label": { px: 0.75, fontSize: 11 },
        }}
      />
    </Tooltip>
  );
}
